module.exports = __webpack_public_path__ + "img/home.0753692e.png";